import React, { useContext, useState, useEffect } from "react";
import "./Ajuda.css";
import NavbarV3 from "../../../components/NavbarV3/NavbarV3.tsx";
import CoresRedux from "../../../contexts/Cor";
import { motion } from "framer-motion";
import { getVideosAjuda } from "../../../services/ModuloGerenciador/Ajuda";
import ToastErro from "../../../components/Toast/ToastErro/ToastErro.tsx";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent.tsx";

function Ajuda() {
	const { profile } = useProfile();

	const { dadosCoresRedux } = useContext(CoresRedux);

	const [loading, setLoading] = useState(true);

	const [videos, setVideos] = useState([]);

	const [textoErro, setTextoErro] = useState("");

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const buscarVideos = async () => {
		setLoading(true);
		await getVideosAjuda(profile?.token)
			.then((result) => {
				setVideos(result.data);
				setLoading(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		if (profile?.token) {
			buscarVideos();
		}
	}, [profile?.token]);

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			className="fundo"
			style={{ backgroundColor: dadosCoresRedux.fundoPadrao, height: "100vh" }}
		>
			<NavbarV3 selecionado="Ajuda" />
			{loading && <LoadingComponent />}
			{!loading && (
				<div className="principal">
					<div className="cardAjuda">
						{videos.map((video, index) => (
							<div key={index} className="videoItem">
								<h3>{video.titulo}</h3>
								<iframe
									className="youtube-video"
									src={video.link}
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowFullScreen
								/>
							</div>
						))}
					</div>
				</div>
			)}
			<div>
				<ToastErro
					texto={textoErro}
					open={openToastErro}
					onClose={handleCloseToastErro}
				/>
			</div>
		</motion.div>
	);
}

export default Ajuda;
